// extracted by mini-css-extract-plugin
export default {"resizer":"Resizer_resizer__cwdr1","closing":"Resizer_closing__AhLTb"};